import { Component, Input, SimpleChanges } from '@angular/core';
import { TipoUrlEnum } from '../../utilidades.index';
import { ArchivoModel } from '../../utilidades.modelos.index';
import { UtilidadesService } from '../../utilidades.servicios.index';

@Component({
	selector: "visor-de-archivos",
	templateUrl: "./visor-de-archivos.component.html",
	styleUrls: [
		"./visor-de-archivos.component.scss"
	]
})
export class VisorDeArchivosComponent {

	@Input("IdGrupo") IdGrupo: number = 0;
	@Input("IdAsociado") IdAsociado: number = 0;
	@Input("IdSistema") IdSistema: number = 0;
	public Archivos: ArchivoModel[] = [];

	get ArchivosSeleccionados(): number {
		return this.Archivos.filter(a => a.Seleccionado).length;
	}

	constructor(
		private Utilidades: UtilidadesService
	) { }

	BuscarIcono(extencion: string): string {
		let Icono: string = Iconos[0].Icono;

		Iconos.forEach(i => {
			if (i.Extenciones.indexOf(extencion) > -1) {
				Icono = i.Icono;
			}
		});

		return Icono;
	}

	ngOnChanges(cambios: SimpleChanges) {
		for (let cambio in cambios) {
			switch (cambio) {
				case "IdGrupo":
				case "IdAsociado":
					this.CargarArchivos();
					break;
			}
		}
	}

	CargarArchivos(): void {
		if (this.IdGrupo && this.IdAsociado) {
			this.Utilidades.Get("Archivos/API/Lista/" + this.IdGrupo + "/" + this.IdAsociado, TipoUrlEnum.Absoluta).subscribe(a => this.Archivos = a.Resultado);
		}
	}

	EliminarArchivosSeleccionados(): void {
		this.Utilidades.CuadroDeConfirmacion("Advertencia!", "¿Desea eliminar los archivos seleccionados?", () => {
			if (this.ArchivosSeleccionados > 0) {
				let Ids: number[] = [];
				let Archivos: ArchivoModel[] = this.Archivos.filter(a => a.Seleccionado);

				Archivos.forEach(a => {
					Ids.push(a.IdArchivo);
				});

				this.Utilidades.Post("Archivos/API/Eliminar", Ids, TipoUrlEnum.Absoluta).subscribe(rta => this.CargarArchivos());
			}
		});
	}

	DescargarArchivo(archivo: ArchivoModel): void {
		archivo.Descargando = true;
		this.Utilidades.GetArchivo("Archivos/API/Descargar/" + archivo.IdArchivo, true, archivo.Descripcion + "." + archivo.Extencion, "application/octet-stream").subscribe(() => {
			archivo.Descargando = false;
		});
	}
}

class InfoIcono {
	public Icono: string = "";
	public Extenciones: string[] = [];

	constructor() { }
}

const Iconos: InfoIcono[] = [
	//Archivo generico --- Tiene que estar primero porque es el ícono por defecto.
	{ Icono: "fas fa-file", Extenciones: [] },

	//Adobe reader
	{ Icono: "fas fa-file-pdf", Extenciones: ["pdf"] },

	//Audios
	{ Icono: "fas fa-file-audio", Extenciones: ["mp3", "wav"] },
	
	//Excel
	{ Icono: "fas fa-file-excel", Extenciones: ["xls", "xlsx", "ods"] },

	//assets/images
	{ Icono: "fas fa-file-image", Extenciones: ["jpg", "png", "gif", "jpeg"] },

	//Videos
	{ Icono: "fas fa-file-video", Extenciones: ["mp4", "mpg", "avi", "mpeg"] },

	//Word
	{ Icono: "fas fa-file-word", Extenciones: ["doc", "docx", "odt"] },

	//Texto plano
	{ Icono: "fas fa-file-alt", Extenciones: ["txt"] },

	//Zip
	{ Icono: "fas fa-file-archive", Extenciones: ["zip", "rar"] }
];